import {TList} from "@/app/[locale]/common/components/Accordion/types";
import {APP_ROUTES} from "../../constants/app";

export const formatSectionData = (about: TList[], industries: TList[], products: TList[], solutions: TList[], services: TList[], t: (key: string) => string) => {
    return {
        about: [{ title: t('aboutUs.title'), href: APP_ROUTES.ABOUT_US }, ...about], industries: [{ title: t('industries.title'), href: APP_ROUTES.INDUSTRIES }, ...industries],
        products: [{ title: t('products.title'), href: APP_ROUTES.PRODUCTS }, ...products], solutions: [{ title: t('solutions.title'), href: APP_ROUTES.SOLUTIONS }, ...solutions],
        services: [{ title: t('services.title'), href: '/services' }, ...services],
    };
};